var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.006,
    height: 24,
    viewBox: "0 0 24.006 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_032-cloud-computing",
    "data-name": "032-cloud-computing",
    transform: "translate(-0.001 -0.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1451",
    "data-name": "Group 1451",
    transform: "translate(0.001 0.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1450",
    "data-name": "Group 1450",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M22.183,8.123A6.674,6.674,0,0,0,22.3,6.907,6.859,6.859,0,0,0,8.988,4.577a3.43,3.43,0,0,0-4.6,2.386A5.145,5.145,0,0,0,5.148,17.2H9.435a.857.857,0,1,0,0-1.715H5.148a3.43,3.43,0,1,1,0-6.859.857.857,0,0,0,.857-.857A1.715,1.715,0,0,1,8.921,6.542a.857.857,0,0,0,1.448-.473,5.139,5.139,0,0,1,10.14,1.685q-.042.25-.108.5a.857.857,0,0,0,.354.943,3.43,3.43,0,0,1-1.888,6.287H16.294a.857.857,0,0,0,0,1.715h2.572a5.144,5.144,0,0,0,3.316-9.073Z",
    transform: "translate(-0.001 -0.056)",
    fill: "#610D24"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1453",
    "data-name": "Group 1453",
    transform: "translate(7.731 7.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1452",
    "data-name": "Group 1452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M163.873,164.031a.857.857,0,0,0-1.191,0l-2.825,2.824V154.348a.857.857,0,1,0-1.715,0v12.506l-2.824-2.823a.857.857,0,0,0-1.212,1.212l4.287,4.287a.857.857,0,0,0,1.213,0l0,0,4.287-4.287A.857.857,0,0,0,163.873,164.031Z",
    transform: "translate(-153.865 -153.491)",
    fill: "#610D24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.a3c01c0a0a0ddcabeb1bbe1da7fe5fd1.svg";
export { ForwardRef as ReactComponent };